module.exports = __webpack_public_path__ + "static/media/YourStoryOurStory-1220x150px@2x.282b79c4.webp";